import { render, staticRenderFns } from "./CustomFieldSetOfOptionsEditor.vue?vue&type=template&id=4e0abdef&"
import script from "./CustomFieldSetOfOptionsEditorVue.ts?vue&type=script&lang=ts&"
export * from "./CustomFieldSetOfOptionsEditorVue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports